import {
  Check,
  Gauge,
  Plug,
  Beaker,
  Wrench,
  RefreshCcw,
  CalendarCheck,
  ShieldCheck,
  Award,
  Activity,
  LifeBuoy,
} from "lucide-react";
import { BRAND } from "@/data/site";

const SERVICE_CHECKLIST = [
  { icon: Beaker, label: "Kaçak Ölçümü Yapılır" },
  { icon: Gauge, label: "Araç Kapasite Uygunluk Testi" },
  { icon: Plug, label: "Araç Elektrik Sistemi Genel Kontrolü" },
  { icon: Wrench, label: "Kutup Başı Oksit ve Korozyon Kontrolü" },
  { icon: Activity, label: "Eski Akü Ölçümü" },
  { icon: CalendarCheck, label: "Yeni Tarihli Akü Takılır" },
  { icon: RefreshCcw, label: "Takım Sonrası Tekrar Ölçüm" },
  { icon: ShieldCheck, label: "2 Yıl Standart Garanti" },
  { icon: Award, label: "Start-Stop (BSG / AGM) Akülerde 3 Yıl Garanti" },
];

export default function ServiceChecklistSection() {
  return (
    <section
      className="relative py-24 bg-[#050A1F] overflow-hidden"
      data-testid="service-checklist-section"
    >
      <div className="absolute inset-0 bg-blueprint opacity-30" />
      <div className="absolute top-1/3 left-0 w-[500px] h-[500px] rounded-full bg-gold/8 blur-[140px]" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] rounded-full bg-inci-blue/15 blur-[140px]" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-14 max-w-3xl">
          <p className="text-gold uppercase tracking-[0.4em] text-xs mb-3">
            Hizmet İçeriği
          </p>
          <h2 className="font-display text-3xl sm:text-5xl font-bold text-balance leading-[1.05]">
            <span className="text-gradient-silver">Star Otogaz'dan akü hizmeti aldığınızda </span>
            <span className="text-gradient-gold">neler yapıyoruz?</span>
          </h2>
          <p className="mt-5 text-white/65 leading-relaxed max-w-2xl">
            Bir aküyü değiştirmek; doğru kapasite, doğru kurulum ve doğru
            testlerle bütünleştiğinde gerçek anlamda hizmet olur. Her akü
            değişiminde adım adım yaptıklarımız:
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {SERVICE_CHECKLIST.map(({ icon: Icon, label }, i) => (
            <div
              key={label}
              data-testid={`checklist-item-${i}`}
              className="group glass rounded-xl p-5 flex items-start gap-4 hover:border-gold/50 transition-all"
            >
              <div className="w-10 h-10 rounded-lg bg-gold/10 border border-gold/30 flex items-center justify-center flex-shrink-0 group-hover:bg-gold/20 group-hover:rotate-6 transition-all duration-500">
                <Icon className="w-4 h-4 text-gold" />
              </div>
              <div className="pt-1">
                <div className="flex items-center gap-2">
                  <span className="font-display font-bold text-gold text-sm">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <Check className="w-3.5 h-3.5 text-gold" />
                </div>
                <div className="text-white font-medium text-sm leading-snug mt-1">
                  {label}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 p-6 sm:p-8 rounded-2xl glass-gold flex flex-col lg:flex-row items-start lg:items-center gap-5 lg:gap-8">
          <div className="w-14 h-14 rounded-2xl gradient-gold flex items-center justify-center flex-shrink-0 glow-gold">
            <LifeBuoy className="w-7 h-7 text-black" />
          </div>
          <div className="flex-1">
            <h3 className="font-display text-xl sm:text-2xl font-bold text-white">
              Bonus: 6 Ay Ücretsiz Yol Yardımı
            </h3>
            <p className="text-white/70 text-sm leading-relaxed mt-1">
              Star Otogaz'dan akü hizmeti alan müşterilerimize tüm bu işlemlere
              ek olarak{" "}
              <span className="text-gold font-semibold">
                6 ay boyunca tamamen ücretsiz yol yardımı
              </span>{" "}
              hediye ediyoruz.
            </p>
          </div>
          <a
            href={`tel:${BRAND.phoneTel}`}
            className="bg-gold text-black font-semibold px-6 py-3 inline-flex items-center gap-2 hover:bg-gold-light hover:scale-105 transition-all w-full lg:w-auto justify-center"
          >
            Hemen Ara
          </a>
        </div>
      </div>
    </section>
  );
}
